export const FETCH_ALL = "FETCH_ALL";
export const ADD_NEW = "ADD_NEW";
export const UPDATE = "UPDATE";
export const DELETE = "DELETE";
export const GET_INVOICE = "GET_INVOICE";
export const FETCH_INVOICE_BY_USER = "FETCH_INVOICE_BY_USER";
export const FILTER_INVOICE = "FILTER_INVOICE";
export const FETCH_INVOICE_BY_PRODUCT = "FETCH_INVOICE_BY_PRODUCT";

export const ALL_CLIENTS = "ALL_CLIENTS";
export const UPDATE_CLIENT = "UPDATE_CLIENT";
export const DELETE_CLIENT = "DELETE_CLIENT";
export const ADD_NEW_CLIENT = "ADD_NEW_CLIENT";
export const FETCH_CLIENTS_BY_USER = "FETCH_PROFILE_USER";

export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const UPDATE_USER = "UPDATE_USER";
export const FETCH_USERS = "FETCH_USERS";
export const START_LOADING = "START_LOADING";
export const END_LOADING = "END_LOADING";
export const FETCH_CLIENT = "FETCH_CLIENT";

export const CREATE_PROFILE = "CREATE_PROFILE";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const DELETE_PROFILE = "DELETE_PROFILE";
export const FETCH_PROFILES = "FETCH_PROFILES";
export const FETCH_PROFILE = "FETCH_PROFILE";
export const FETCH_PROFILE_BY_USER = "FETCH_PROFILE_USER";
export const FETCH_PROFILES_BY_USER = "FETCH_PROFILES_BY_USER";

//products

export const ALL_PRODUCTS = "ALL_PRODUCTS";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const ADD_NEW_PRODUCT = "ADD_NEW_PRODUCT";
export const FETCH_PRODUCT = "FETCH_PRODUCT";
export const FETCH_PRODUCTS_BY_USER = "FETCH_PRODUCTS_BY_USER";

//assistants

export const UPDATE_ASSISTANT = "UPDATE_ASSISTANT";
export const DELETE_ASSISTANT = "DELETE_ASSISTANT";
export const ADD_NEW_ASSISTANT = "ADD_NEW_ASSISTANT";
export const FETCH_ASSISTANTS_BY_USER = "FETCH_ASSISTANTS_BY_USER";

//xl

export const GET_XL = "GET_XL";

//Bank

export const FETCH_ONE_BANK = "FETCH_ONE_BANK";
export const DELETE_BANK = "DELETE_BANK";
export const ADD_NEW_BANK = "ADD_NEW_BANK";
export const FETCH_ALL_BANK = "FETCH_ALL_BANK";
//checks
export const FETCH_CHECKS = "FETCH_CHECKS";

//billing cycle
export const FETCH_ALL_BILLING_CYCLE = "FETCH_ALL_BILLING_CYCLE";
export const FETCH_ONE_BILLING_CYCLE = "FETCH_ONE_BILLING_CYCLE";
export const CREATE_BILLING_CYCLE = "CREATE_BILLING_CYCLE";
export const FETCH_DAILY_PAYMENTS = "FETCH_DAILY_PAYMENTS";
export const CHECK_BILLING_CYCLE = "CHECK_BILLING_CYCLE";

//account receivables

export const FETCH_ALL_ACCOUNT_RECEIVABLES = "FETCH_ALL_ACCOUNT_RECEIVABLES";
export const CREATE_ACCOUNT_RECEIVABLES = "CREATE_ACCOUNT_RECEIVABLES";

//Payment
export const FETCH_PAYMENT = "FETCH_PAYMENT";
export const UPDATE_PAYMENT = "UPDATE_PAYMEN";
